export const escape = (str) => {
    const tagsToReplace = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '\\': '&bsol;'
    };
    return str.replace(/[&<>"'\\]/g, function(tag) {
        return tagsToReplace[tag] || tag;
    });
};

export const deentitize = (str) => {
    let ret = str.replace(/&gt;/g, '>');
    ret = ret.replace(/&lt;/g, '<');
    ret = ret.replace(/&quot;/g, '"');
    ret = ret.replace(/&#x27;/g, "'");
    ret = ret.replace(/&bsol;/g, '\\');
    ret = ret.replace(/&amp;/g, '&');
    ret = ret.replace("('", "['");
    ret = ret.replace("')", "']");
    ret = ret.replace('("', '["');
    ret = ret.replace('")', '"]');
    return ret;
};

export function fncInputCheck(input) {
    const regRomaji = '!-~';
    const regPunc = '\u300c\u300d';        // 「 」
    const regHira = '\u3040-\u309f';       // ひらがな
    const regKata = '\u30a0-\u30ff';       // カタカナ
    const regFullWidthRoman = '\uff01-\uff9f';
    const regCommonKanji = '\u4e00-\u9faf'; // 通用漢字
    const regUncommKanji = '\u3400-\u4dbf'; // 通用外漢字
    const regOtherChar = '\u02dc\u201c\u201d\u2018\u2019'; // ˜ “ ” ‘ ’

    const regstr_container = 
        '^[' +
        regRomaji +
        regPunc +
        regHira +
        regKata +
        regFullWidthRoman +
        regCommonKanji +
        regUncommKanji +
        regOtherChar +
        ']+$';

    if (!input) {
        input = "";
    }

    return RegExp(regstr_container).test(input);
}
